import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DateAdapter } from "@angular/material/core";
import { LanguageService } from "./core/lang/language.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public static readonly DEV_PWD_KEY = 'devPassword';
  public static readonly DEV_PWD = 'M@g!Pall3t';
  public protectedAcces = environment.protectedAcces;
  
  public form: FormGroup<{
    devPassword: FormControl<string>
  }>;
  
  constructor(private readonly languageService: LanguageService,
              private dateAdapter: DateAdapter<any>
  ) {
    this.form = new FormGroup<{
      devPassword: FormControl<string>
    }>({
      devPassword: new FormControl<string>('')
    });
    this.languageService.onLanguageChange.subscribe((event) => this.dateAdapter.setLocale(event.lang));
  }
  
  ngOnInit() {
    this.loadScript(`https://maps.googleapis.com/maps/api/js?key=${environment.googleAPIKey}&libraries=places&language=fr&callback=Function.prototype`);
  }
  
  public setDevPassword(): void {
    localStorage.setItem(
      AppComponent.DEV_PWD_KEY,
      this.form.get(AppComponent.DEV_PWD_KEY).value
    );
  }
  
  public get allowedAccess(): boolean {
    return (
      !this.protectedAcces ||
      localStorage.getItem(AppComponent.DEV_PWD_KEY) === AppComponent.DEV_PWD
    );
  }
  
  private loadScript(name: string) {
    return new Promise<void>((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = name;
      document.getElementsByTagName('head')[0].appendChild(script);
      resolve()
    });
  }
}
